export const getDynamicLightingThresholdOptions = thresholdOptions => {
  if (!Array.isArray(thresholdOptions)) {
    return []
  }

  return thresholdOptions.filter(option => (
    option &&
    option.key &&
    String(option.key).toLowerCase() !== 'null'
  ))
}

const findThresholdByValue = (value, thresholdOptions) => {
  const numericValue = Number(value)

  if (Number.isNaN(numericValue)) {
    return undefined
  }

  return getDynamicLightingThresholdOptions(thresholdOptions).find(option => {
    if (option.max === undefined || option.max === null) {
      return numericValue >= option.min
    }

    return numericValue >= option.min && numericValue <= option.max
  })
}

export const getDynamicLightingThresholdLabel = (value, thresholdOptions) => {
  const threshold = findThresholdByValue(value, thresholdOptions)

  return threshold ? threshold.label : ''
}

export const getDynamicLightingThresholdKey = (value, thresholdOptions) => {
  const threshold = findThresholdByValue(value, thresholdOptions)

  return threshold ? threshold.key : ''
}

export const getDynamicLightingThresholdValue = (threshold, thresholdOptions) => {
  const normalizedThreshold = String(threshold).toLowerCase()

  const thresholdOption = getDynamicLightingThresholdOptions(thresholdOptions).find(option => (
    String(option.key).toLowerCase() === normalizedThreshold ||
    String(option.label).toLowerCase() === normalizedThreshold
  ))

  return thresholdOption ? thresholdOption.value : 0
}
